<template>
  <div class="empty-data">
    <img src="@/assets/images/empty.png" alt class="empty-image">
    <span>{{description}}</span>
  </div>
</template>

<script>
export default {
  props: {
    description: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>

<style lang="scss" scoped>
.empty-data {
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #9FA3B0;
  .empty-image {
    width: 60%;
    margin-bottom: 1px;
  }
}
</style>
